<template>
  <div class="root">
    <ul class="ul_left">
      <li>
        <img src="../assets/img/土地咨询1.png" alt />
      </li>
    </ul>
    <ul class="ul_right">
      <li class="li_right" v-for="(item, index) in titles.slice((currentpage - 1) * pagesize, currentpage * pagesize)"
        :key="index">
        <router-link :to="{ name: '土地咨询详情', query: { id: item.id } }">{{ item.title }}</router-link>
        <p>
          <span style>{{ item.logintime }}</span>
          <span>来源：{{ item.source }}</span>
        </p>
      </li>
    </ul>

    <div v-if="titles.length > 0">
      <el-pagination prev-text="上一页" next-text="下一页" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-size="pagesize" layout="prev, pager, next, jumper" :total="titles.length"></el-pagination>
    </div>
    <h3 v-else style="font-size:24px">暂无数据</h3>
  </div>
</template>

<script>
export default {
  data() {
    return {

      titles: [],
      //   每页数据条数
      pagesize: 10,
      currentpage: 1,
      inputpage: 1,
    };
  },
  created() {
    // 土地咨询数据
    let url = "tudizixun";
    // console.log('土地咨询');
    // console.log(this.ajax_url(url).data);
    this.titles = this.ajax_url(url).data;
  },
  mounted() { },
  computed: {},
  watch: {},
  methods: {

    // 当前每夜多少条
    handleSizeChange(size) {
      this.pagesize = size;
    },
    // 当前页数
    handleCurrentChange(currentpage) {
      this.currentpage = currentpage;
    },
  },
};
</script>

<style scoped>
.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 35px;
  width: 1860px;
  max-height: 1393px;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  opacity: 1;
  overflow: hidden;
}

.ul_left {
  display: block;
  width: 260px;
  height: auto;
  float: left;
  /* background-color: rebeccapurple; */
  padding: 40px 100px;
  list-style: inside none;
}

.ul_left>li {
  display: block;
  width: 260px;
  height: 92px;
  /* background-color: red; */
  margin-bottom: 20px;
  cursor: pointer;
}

.ul_right {
  display: block;
  width: 1300px;
  max-height: 1230px;
  overflow: hidden;
  list-style: inside none;
  margin-bottom: 40px;
}

.ul_right .li_right {
  display: block;
  width: 1300px;
  height: 122px;
  border-bottom: 1px dotted #bebebe;
}

.li_right>a {
  display: block;
  padding: 37px 0 19px 0;
  max-width: 1200px;
  height: 26px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 26px;
  color: #666666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.li_right>p {
  display: block;
  width: auto;

  height: 21px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 21px;
  color: #999999;
}

.li_right>p>span {
  display: inline-block;
  width: 250px;
}

.el-pagination {
  text-align: center;
}
</style>

